import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AnnouncementIcon(props: IconProps) {
    return <Icon {...props} iconKey={"announcement"}/>
}
